import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'

export const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/quote" />
  },
  {
    path: '/quote',
    exact: true,
    component: lazy(() => import('pages/Quote'))
  },
  {
    path: '/quote/:id',
    exact: true,
    component: lazy(() => import('pages/Quote'))
  },
  {
    path: '/quote/:id',
    exact: true,
    component: lazy(() => import('pages/Quote'))
  },
  {
    path: '/quote/:id/:action',
    exact: true,
    component: lazy(() => import('pages/Quote/Action'))
  },
  { path: '/error/network', exact: true, component: lazy(() => import('pages/Error/Error502')) },

  {
    component: lazy(() => import('pages/Error/Error404'))
  }
]
